export default "__VITE_ASSET__Ci5Xe6nI__"